<form [formGroup]='registerForm' (ngSubmit)='submitForm(registerForm)'>


    <label >firstName :</label>
    <input  formControlName="first_name"  type="text" class="form-control mb-2" >

    <div *ngIf="registerForm.get('first_name').errors && registerForm.get('first_name').touched"  class="alert border border-danger">
        <p *ngIf="registerForm.get('first_name').errors.required">firstName is Required</p>
        <p *ngIf="registerForm.get('first_name').errors.minlength">firstName minLength is 3</p>
        <p *ngIf="registerForm.get('first_name').errors.maxlength">firstName maxLength is 8</p>

    </div>

    <label >lastName :</label>
    <input  formControlName="last_name"  type="text" class="form-control mb-2" >

    <div *ngIf="registerForm.get('last_name').errors && registerForm.get('last_name').touched"  class="alert border border-danger">
        <p *ngIf="registerForm.get('last_name').errors.required">lastName is Required</p>
        <p *ngIf="registerForm.get('last_name').errors.minlength">lastName minLength is 3</p>
        <p *ngIf="registerForm.get('last_name').errors.maxlength">lastName maxLength is 8</p>

    </div>

    <label >email :</label>
    <input  formControlName="email"  type="email" class="form-control mb-2" >
    <div *ngIf="registerForm.get('email').errors && registerForm.get('email').touched"  class="alert border border-danger">
        <p *ngIf="registerForm.get('email').errors.required">email is Required</p>
        <p *ngIf="registerForm.get('email').errors.email">email invalid</p>

    </div>
    <label >age :</label>
    <input  formControlName="age"  type="text" class="form-control mb-2" >
    <div *ngIf="registerForm.get('age').errors && registerForm.get('age').touched"  class="alert border border-danger">
        <p *ngIf="registerForm.get('age').errors.required">age is Required</p>
        <p *ngIf="registerForm.get('age').errors.min"> min value is 10</p>
        <p *ngIf="registerForm.get('age').errors.max"> max value is 80</p>

    </div>
    <label >password :</label>
    <input  formControlName="password"  type="password" class="form-control mb-2" >
    <div *ngIf="registerForm.get('password').errors && registerForm.get('password').touched"  class="alert border border-danger">
        <p *ngIf="registerForm.get('password').errors.required">password is Required</p>
        <p *ngIf="registerForm.get('password').errors.pattern"> password must include a-z from 3-10</p>

    </div>
    <div *ngIf="error" class="alert alert-danger">
        {{error}}
    </div>

    <br/>
    <button type="submit" [disabled]='registerForm.invalid' class="btn btn-info float-right">register</button>

</form>
